/**
 * 🟦 V11.4 — Cliente del endpoint /api/ai/style-infer.
 */
import { BACKEND_URL } from '../../../config/api';

export async function analyzeStyle({ imageB64, computed_styles, tag }) {
  const API = `${BACKEND_URL}/api`;
  const res = await fetch(`${API}/ai/style-infer`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      image_b64: imageB64 || null,
      computed_styles: computed_styles || null,
      tag: tag || 'div',
    }),
  });
  if (!res.ok) {
    const txt = await res.text().catch(() => '');
    throw new Error(`style_infer_failed: ${res.status} ${txt}`);
  }
  return res.json();
}
